export type TrialBookingView = 'upcoming' | 'all';

export function filterTrialBookings<
  T extends { appointmentStatus: string; startTime: string },
>(
  trials: Array<T>,
  view: TrialBookingView,
  today: string,
  getTrialDay: (startTime: string) => string,
): Array<T> {
  if (view === 'all') return trials;

  return trials.filter(
    (trial) =>
      trial.appointmentStatus !== 'Cancelled' &&
      getTrialDay(trial.startTime) >= today,
  );
}
